"use strict";
globalThis.Kozijnen = (() => {
  const { $, show, hide, formatCurrency, clampInt } = Utils;
  const state = State.wizard;
  const TYPE_LABELS = Object.freeze({
    vast: "vast glas",
    draaikiep: "draai/kiep",
    deur: "kozijndeur"
  });
  const getElementDescription = (el) => {
    const typeLabel = TYPE_LABELS[el.type] || el.type;
    if (el.type === "deur") {
      return typeLabel;
    }
    const vakLabel = el.vakken === 1 ? "vak" : "vakken";
    return `${typeLabel} \u2022 ${el.vakken} ${vakLabel}`;
  };
  let els = null;
  const init = () => {
    els = {
      list: $("#wizard-elements-list"),
      emptyState: $("#wizard-empty-state"),
      vakkenHeader: $("#wizard-vakken-header"),
      vakkenSection: $("#wizard-vakken-section"),
      currentDims: $("#wizard-current-dims"),
      addBtn: $("#wizard-add-btn"),
      addAnotherBtn: $("#wizard-add-another-btn"),
      continueBtn: $("#wizard-continue-btn"),
      actionsContainer: $("#wizard-kozijnen-actions"),
      widthInput: $("#wizard-width-3a"),
      heightInput: $("#wizard-height-3a"),
      displayWidth: $("#wizard-display-width"),
      displayHeight: $("#wizard-display-height"),
      displayType: $("#wizard-display-type"),
      cvTrigger: $("#cv-measure-trigger-3a"),
      cvTriggerMulti: $("#cv-measure-trigger-multi"),
      estimate: $("#wizard-estimate"),
      estimateCard: $("#wizard-estimate-card"),
      estimateNote: $("#wizard-estimate-note")
    };
    els.addBtn?.addEventListener("click", addCurrentElement);
    els.addAnotherBtn?.addEventListener("click", () => {
      resetCurrentElement();
      Wizard.showStep("3a");
    });
    els.continueBtn?.addEventListener("click", () => Wizard.navigateNext());
    els.cvTrigger?.addEventListener("click", openCVMeasure);
    els.cvTriggerMulti?.addEventListener("click", openCVMeasureMulti);
    state.subscribe(render, "elements");
    state.subscribe(fetchEstimate, ["elements", "hout", "glas", "afwerking", "ral", "montage"]);
    return { addElement, removeElement, getElements, render, openCVMeasureMulti };
  };
  const openCVMeasure = () => {
    CVMeasure.open(
      // Single frame callback
      (result) => {
        if (result && els.widthInput && els.heightInput) {
          els.widthInput.value = result.width;
          els.heightInput.value = result.height;
          updateCVTriggerState(true);
        }
      }
    );
  };
  const openCVMeasureMulti = () => {
    CVMeasure.openMulti((results) => {
      if (results && results.length > 0) {
        const newElements = results.map((result) => ({
          width: result.width,
          height: result.height,
          type: result.label === "door" ? "deur" : "vast",
          vakken: result.label === "door" ? 1 : 2
        }));
        addMultipleElements(newElements);
        Wizard.showStep("3");
      }
    });
  };
  const updateCVTriggerState = (success) => {
    if (!els.cvTrigger) return;
    const iconWrap = els.cvTrigger.querySelector("div:first-child");
    const subtitle = els.cvTrigger.querySelector(".text-neutral-500");
    if (success) {
      iconWrap?.classList.remove("bg-purple-100");
      iconWrap?.classList.add("bg-green-100");
      iconWrap?.querySelector("[data-lucide]")?.classList.replace("text-purple-700", "text-green-700");
      if (subtitle) subtitle.textContent = "Afmetingen ingevuld via foto";
      els.cvTrigger.classList.add("border-green-300", "bg-green-50");
      els.cvTrigger.classList.remove("border-neutral-200");
    } else {
      iconWrap?.classList.add("bg-purple-100");
      iconWrap?.classList.remove("bg-green-100");
      iconWrap?.querySelector("[data-lucide]")?.classList.replace("text-green-700", "text-purple-700");
      if (subtitle) subtitle.textContent = "Upload een foto met referentie";
      els.cvTrigger.classList.remove("border-green-300", "bg-green-50");
      els.cvTrigger.classList.add("border-neutral-200");
    }
  };
  const addCurrentElement = () => {
    storeCurrentDimensions();
    const width = clampInt(state.get("currentWidth"), 100, 1e4, 0);
    const height = clampInt(state.get("currentHeight"), 100, 1e4, 0);
    const type = state.get("currentType") || "vast";
    const vakken = type === "deur" ? 1 : state.get("currentVakken") || 2;
    if (!width || !height) {
      Validation.showInlineMessage(els.addBtn?.parentElement, "Vul eerst de afmetingen in");
      return false;
    }
    const success = addElement({ width, height, type, vakken });
    return success;
  };
  const addMultipleElements = (newItems) => {
    const elements = state.get("elements") || [];
    const addedItems = [];
    newItems.forEach((item) => {
      addedItems.push({
        id: Utils.uid(),
        width: item.width,
        height: item.height,
        type: item.type,
        vakken: item.vakken,
        added: Date.now()
      });
    });
    resetCurrentElement();
    state.set("elements", [...elements, ...addedItems]);
    fetchEstimate();
    return true;
  };
  const addElement = ({ width, height, type, vakken }) => {
    const elements = state.get("elements") || [];
    elements.push({
      id: Utils.uid(),
      width,
      height,
      type,
      vakken,
      added: Date.now()
    });
    resetCurrentElement();
    state.set("elements", [...elements]);
    fetchEstimate();
    return true;
  };
  const removeElement = (id) => {
    const elements = state.get("elements") || [];
    state.set("elements", elements.filter((e) => e.id !== id));
    fetchEstimate();
  };
  const getElements = () => state.get("elements") || [];
  const resetCurrentElement = () => {
    state.update({
      currentWidth: null,
      currentHeight: null,
      currentType: "vast",
      currentVakken: 2
    });
    if (els.widthInput) els.widthInput.value = "";
    if (els.heightInput) els.heightInput.value = "";
    const vastRadio = $('input[name="wizard-type-3a"][value="vast"]');
    if (vastRadio) vastRadio.checked = true;
    const vakkenRadio = $('input[name="wizard-vakken"][value="2"]');
    if (vakkenRadio) vakkenRadio.checked = true;
    updateCVTriggerState(false);
    CVMeasure.reset();
    Wizard.refreshStyles();
  };
  const render = () => {
    const elements = getElements();
    if (!els.list) return;
    const isAddingNew = state.get("currentWidth") && state.get("currentHeight");
    if (elements.length === 0) {
      els.list.innerHTML = "";
      show(els.emptyState);
      show(els.vakkenHeader);
      show(els.vakkenSection);
      show(els.currentDims);
      hide(els.actionsContainer);
      show(els.addBtn);
      return;
    }
    hide(els.emptyState);
    if (isAddingNew) {
      show(els.vakkenHeader);
      show(els.vakkenSection);
      show(els.currentDims);
      show(els.addBtn);
      hide(els.actionsContainer);
    } else {
      hide(els.vakkenHeader);
      hide(els.vakkenSection);
      hide(els.currentDims);
      hide(els.addBtn);
      show(els.actionsContainer);
    }
    els.list.innerHTML = elements.map((el, i) => `
            <div class="element-item bg-white border border-neutral-200 p-3 flex items-center gap-3" data-id="${el.id}">
                <div class="w-10 h-10 bg-neutral-100 flex items-center justify-center text-neutral-600 font-bold shrink-0">
                    ${i + 1}
                </div>
                <div class="flex-1 min-w-0">
                    <div class="font-semibold text-neutral-900 text-sm">
                        ${el.width} \xD7 ${el.height} mm
                    </div>
                    <div class="text-xs text-neutral-500">
                        ${getElementDescription(el)}
                    </div>
                </div>
                <button type="button" class="element-remove w-8 h-8 flex items-center justify-center text-neutral-400 hover:text-red-600 transition-colors" data-remove="${el.id}">
                    <i data-lucide="trash-2" class="w-4 h-4"></i>
                </button>
            </div>
        `).join("");
    els.list.querySelectorAll(".element-remove").forEach((btn) => {
      btn.addEventListener("click", () => removeElement(btn.dataset.remove));
    });
    globalThis.lucide?.createIcons();
  };
  let estimateController = null;
  const fetchEstimate = async () => {
    const elements = getElements();
    if (elements.length === 0) {
      state.set("estimate", null);
      updateEstimateUI(null);
      return;
    }
    estimateController?.abort();
    estimateController = new AbortController();
    const payload = {
      els: elements.map((e) => ({
        widthMm: e.width,
        heightMm: e.height,
        type: e.type,
        vakken: e.vakken
      })),
      wood: state.get("hout"),
      glass: state.get("glas"),
      finish: state.get("afwerking"),
      ral: state.get("ral"),
      montage: state.get("montage") === "ja" || state.get("montage") === true
    };
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ?? "";
      const response = await fetch("/api/estimate/kozijnen", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify(payload),
        signal: estimateController.signal
      });
      if (response.ok) {
        const data = await response.json();
        state.set("estimate", data);
        updateEstimateUI(data);
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error("Estimate fetch error:", err);
      }
    }
  };
  const updateEstimateUI = (data) => {
    if (!els.estimate) return;
    if (!data) {
      els.estimate.textContent = "\u2014";
      if (els.estimateNote) els.estimateNote.textContent = "";
      hide(els.estimateCard);
      return;
    }
    show(els.estimateCard);
    if (data.low && data.high) {
      els.estimate.textContent = `${formatCurrency(data.low)} \u2013 ${formatCurrency(data.high)}`;
    } else if (data.low) {
      els.estimate.textContent = formatCurrency(data.low);
    }
    if (els.estimateNote && data.note) {
      els.estimateNote.textContent = data.note;
    }
  };
  const storeCurrentDimensions = () => {
    const width = clampInt(els.widthInput?.value, 100, 1e4, 0);
    const height = clampInt(els.heightInput?.value, 100, 1e4, 0);
    const type = Wizard.getSelected("wizard-type-3a") || "vast";
    state.update({
      currentWidth: width,
      currentHeight: height,
      currentType: type
    });
    if (els.displayWidth) els.displayWidth.textContent = width || "\u2014";
    if (els.displayHeight) els.displayHeight.textContent = height || "\u2014";
    if (els.displayType) els.displayType.textContent = `(${TYPE_LABELS[type] || type})`;
    render();
    return { width, height, type };
  };
  const validateStep3a = () => {
    const width = clampInt(els.widthInput?.value, 100, 1e4, 0);
    const height = clampInt(els.heightInput?.value, 100, 1e4, 0);
    if (!width || !height) {
      Validation.showInlineMessage(
        els.widthInput?.closest(".bg-white"),
        "Vul de breedte en hoogte in"
      );
      if (!width && els.widthInput) els.widthInput.focus();
      else if (!height && els.heightInput) els.heightInput.focus();
      return false;
    }
    return true;
  };
  const validateStep3 = () => {
    const elements = getElements();
    if (elements.length === 0) {
      Validation.showInlineMessage(
        els.emptyState?.parentElement,
        "Voeg minimaal \xE9\xE9n kozijn toe"
      );
      return false;
    }
    return true;
  };
  return Object.freeze({
    init,
    addElement,
    addMultipleElements,
    addCurrentElement,
    removeElement,
    getElements,
    render,
    storeCurrentDimensions,
    validateStep3a,
    validateStep3,
    resetCurrentElement,
    fetchEstimate
  });
})();
